import { ThemeSkin, ThemeOptions, ThemeVariant } from '@wix/da-react-context/pkg/ThemeContext';

export function getBackgroundVariant(
  theme: ThemeOptions = ThemeOptions.DARK,
  themeSkin?: ThemeSkin
): ThemeVariant {
  if (themeSkin === ThemeSkin.GREEN && theme === ThemeOptions.LIGHT) {
    return 'green';
  }

  return theme;
}
